/**
 * Created by huning on 2019/07/01.
 */

import React, { PureComponent } from 'react'
import cls from 'classnames'

import style from './index.less'

const Paper = React.forwardRef((props, ref) => {
  const { title, height, className } = props
  const outerStyle = {
    boxShadow: `0 0 ${props.level ? props.level * 4 : 4}px rgba(53, 67, 76, 0.04)`,
    height: props.height ? props.height : '100%'
  }
  return (
    <div className={cls(style.paper, className)} style={outerStyle} ref={ref}>
      {title ? (
        <div className={style['paper-title']} style={{ marginBottom: '16px' }}>
          {title}
        </div>
      ) : (
        ''
      )}
      {props.children}
    </div>
  )
})

export default Paper
